<!--
 * @Author: zhb 1822394027@qq.com
 * @Date: 2022-10-05 11:21:08
 * @LastEditors: zhb 1822394027@qq.com
 * @LastEditTime: 2022-10-06 14:56:34
 * @FilePath: \huayue\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png" />
    <hello-world msg="Welcome to Your Vue.js App" /> -->
    <div v-if="blockHadheight" class="hadheight" style="display: block;"></div>
    <router-view />
  </div>
</template>

<script>
// import HelloWorld from './components/hello-world.vue';

export default {
  name: 'App',
  components: {
    // HelloWorld,
  },
  data() {
    return {
      blockHadheight: true
    }
  },
  watch: {
    '$route': {
      handler(to, from) {
        if(to.path == '/privacy') {
          this.blockHadheight = false
        }else{
          this.blockHadheight = true
        }
      },
      deep: true,
      immediate: true,
    }
  }
};
</script>

<style>

*{
  margin: 0;
  padding: 0;
}
ul li{
  list-style: none ;
}
a {
  text-decoration: none;
}
img {
  image-rendering:-moz-crisp-edges;
	image-rendering:-o-crisp-edges;
	image-rendering:-webkit-optimize-contrast;
	image-rendering: crisp-edges;
	-ms-interpolation-mode:nearest-neighbor;
}
.hadheight{
  background: #fff;
  height: 70px;
}
/* html{
}
html,body,#app{
  width: 100%;
  height: 100%;
  overflow: hidden;
} */
</style>
